import React from 'react'
import { Shell } from '~/components/molecules/Shell'
import * as S from './styled'
import { InformationSection } from '~/components/molecules/InformationSection'

export const Screen = () => (
  <Shell>
    <S.ScreenWrapper>
      <S.FeatureImageWrapper>
        <S.FeatureImage
          alt={''}
          src={'/images/about/horses.webp'}
          priority={true}
          objectFit={'cover'}
          objectPosition={'50% 12%'}
          layout={'fill'}
        />
      </S.FeatureImageWrapper>

      <S.WhyCustomersPreferSection>
        <InformationSection
          imageSrc={'/images/about/buffalo.webp'}
          header={'Why customers prefer to deal with a real bank'}
          highlightHeader={true}
        >
          <p>
            Custodia has all the benefits of being a bank with expertise in
            digital assets &mdash; plus, as a depository institution, we’re
            eligible to connect directly with the Federal Reserve payment
            system, removing middlemen and layers of fees. In particular:
          </p>
          <ul>
            <li>
              U.S. banks with direct access to the Federal Reserve via a master
              account can directly clear payments for their customers at the
              Federal Reserve, reducing the cost, delays, reconciliation
              headaches and counterparty risk involved with traditional
              intermediaries.
            </li>
            <li>
              Banks are defined as “qualified custodians” under the Investment
              Advisers Act and the SEC’s Custody Rule.
            </li>
            <li>
              Banks are defined as a “good control location” under the SEC’s
              Customer Protection Rule.
            </li>
          </ul>
          <p>
            For the digital asset industry specifically, Custodia is designed to
            provide real-time settlement finality for U.S. dollar payments in
            digital asset transactions. Our digital asset competitors rely on
            other clearing banks to facilitate fiat transactions. This practice
            increases both counterparty credit risk and settlement delays. As a
            result, without direct access to U.S. dollar clearing, our
            competitors cannot execute on a settlement risk-free basis between a
            digital asset and fiat currency.{' '}
            <em>
              <S.Strong>Custodia aims to fill this critical gap.</S.Strong>
            </em>
          </p>
        </InformationSection>
      </S.WhyCustomersPreferSection>

      <S.MountainHeaderImage
        alt={''}
        src={'/images/about/mountain-outline.png'}
        loading={'lazy'}
      />
      <S.InformationSection>
        <S.InformationImageWrapper>
          <S.InformationImage
            alt={''}
            src={'/images/about/prairie.webp'}
            layout={'fill'}
            objectFit={'cover'}
          />
        </S.InformationImageWrapper>
        <S.InformationContent>
          <h2>Wyoming and the Digital Asset Frontier</h2>
          <S.InlineInformationImageWrapper>
            <S.InformationImage
              alt={''}
              src={'/images/about/prairie.webp'}
              layout={'fill'}
              objectFit={'cover'}
            />
          </S.InlineInformationImageWrapper>
          <p>
            Wyoming law provides Custodia’s customers with clear legal title to
            their digital assets. The state’s property rights-oriented approach
            to digital asset laws makes Wyoming a customer-friendly jurisdiction
            for digital asset market participants.
          </p>
          <p>
            In 2019, the Wyoming Legislature enacted HB 74, which authorized the
            chartering of special purpose depository institutions (SPDIs). These
            institutions are banks that receive deposits and conduct other
            incidental activities, including fiduciary asset management,
            custody, and related activities, but cannot lend customer fiat
            deposits and must instead hold these customer fiat deposits 100% in
            reserve.
          </p>
          <p>
            As a Wyoming SPDI, Custodia is subject to Wyoming’s
            customer&ndash;friendly bailment laws, which are designed to ensure
            that legal title to a digital asset remains with the customer and
            not their custodian. In other words, similar to a coat check or
            valet parking, customer assets belong to the customer and are
            legally segregated from the other assets of the institution.
            Moreover, in contrast to traditional custody arrangements, this
            legal segregation is protected by statute instead of merely by a
            contract that could be broken in a trust company’s bankruptcy.
            Bailment is designed to provide a bankruptcy-remote and
            off-balance-sheet status for customer digital assets.
          </p>
        </S.InformationContent>
      </S.InformationSection>

      {/*<S.WhoWeAreSection>*/}
      {/*  <h1>Who we are</h1>*/}
      {/*  <S.WhoWeAreProfileGrid>*/}
      {/*    <S.WhoWeAreProfiles>*/}
      {/*      <AboutProfile*/}
      {/*        name={'Caitlin Long'}*/}
      {/*        title={'Chief Executive Officer'}*/}
      {/*        profile={*/}
      {/*          'Caitlin is Chairman & CEO of Avanti. A 22-year Wall Street veteran who has been active in Bitcoin since 2012, Caitlin volunteered to help Wyoming’s lawmakers create an oasis for blockchain companies in the U.S. From 2016-18 she jointly spearheaded a blockchain project for delivering market index data to Vanguard at a previous start-up. On Wall Street, Caitlin ran Morgan Stanley’s pension solutions business (2007-2016), held senior roles at Credit Suisse (1997-2007) and began her career at Salomon Brothers (1994-1997). She holds a J.D. from Harvard Law School, an M.P.P. from the Kennedy School of Government and a B.A. from the University of Wyoming.'*/}
      {/*        }*/}
      {/*      />*/}
      {/*      <AboutProfile*/}
      {/*        name={'Zev Shimko'}*/}
      {/*        title={'Chief Operating Officer'}*/}
      {/*        profile={*/}
      {/*          'Zev is Chief Operating Officer of Avanti. Prior to joining Avanti, Zev was a director at Figure Technologies, focusing on its enterprise blockchain efforts. Zev has held senior capital markets and corporate development roles at various Fintech companies including Upstart Holdings, Prosper Marketplace, and SALT Lending. Zev started his career at Morgan Stanley in global capital markets, where he was promoted as part of its STAR program and where he and Caitlin worked together. Zev received his B.S. from Northeastern University.'*/}
      {/*        }*/}
      {/*      />*/}
      {/*      <AboutProfile*/}
      {/*        name={'Chuck Thompson'}*/}
      {/*        title={'Chief Legal Officer // Chief Compliance Officer'}*/}
      {/*        profile={*/}
      {/*          'Chuck is Chief Legal Officer and Chief Compliance Officer of Avanti. He has been active in Bitcoin since 2011. Prior to joining Avanti, Chuck was CEO of Blockchain Consulting LLC and was chief compliance officer of LedgerX, where he and Bryan worked together. Before that, he was in house counsel at capital markets firms, including Morgan Stanley, and practiced law at Cleary, Gottlieb, Steen & Hamilton and Shearman & Sterling. Chuck holds a J.D. from the University of Illinois and a B.A. from Miami University.'*/}
      {/*        }*/}
      {/*      />*/}
      {/*      <AboutProfile*/}
      {/*        name={'Mike Borges'}*/}
      {/*        title={'Chief Financial Officer'}*/}
      {/*        profile={*/}
      {/*          'Mike is the Chief Financial Officer of Avanti. He joined Avanti from Beneficial State Bank in Oakland, California, after serving as the Controller for five years, building its FDICIA internal controls program, successfully implementing systems supporting core banking and related integrations, along with overseeing accounting operations. As a CPA, Mike previously held accounting roles at Bay Area technology companies Mosaic and Hotwire. Prior to this he spent nearly nine years in public accounting with Moss Adams LLP, where he served community banks, other financial service companies and other mid-size public and private companies.'*/}
      {/*        }*/}
      {/*      />*/}
      {/*    </S.WhoWeAreProfiles>*/}
      {/*    <S.WhoWeAreProfileCornerImage*/}
      {/*      alt={''}*/}
      {/*      src={'/images/about/minerals.webp'}*/}
      {/*    />*/}
      {/*  </S.WhoWeAreProfileGrid>*/}
      {/*</S.WhoWeAreSection>*/}
    </S.ScreenWrapper>
  </Shell>
)

interface AboutProfileProps {
  name: string
  title: string
  profile: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AboutProfile = ({ name, title, profile }: AboutProfileProps) => (
  <S.AboutProfile>
    <h3>{name}</h3>
    <h4>{title}</h4>
    <p>{profile}</p>
  </S.AboutProfile>
)
